enum WebserviceBarcodeFields {
	ENABLED = "barcode_enabled",
	INSTANCES = "barcode_instances",
	QUEUE = "barcode_queue",
	LATENCY = "barcode_latency",
}

export default WebserviceBarcodeFields;